// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let PageUITitle = require("../../components/PageTitle/PageUITitle.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let ContentBox__Jsx3 = require("../../uikit/reason/atoms/ContentBox/ContentBox__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let SubusersAddUserForm = require("./SubusersAddUserForm.bs.js");
let SubusersPageAccountsList = require("./SubusersPageAccountsList.bs.js");
let SubusersPageRelayQuery_graphql = require("../../__generated__/SubusersPageRelayQuery_graphql.bs.js");

let convertVariables = SubusersPageRelayQuery_graphql.Internal.convertVariables;

let convertResponse = SubusersPageRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = SubusersPageRelayQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, SubusersPageRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, SubusersPageRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(SubusersPageRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(SubusersPageRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(SubusersPageRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(SubusersPageRelayQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function SubusersPageRelay(props) {
  let data = use(undefined, undefined, undefined, undefined);
  let match = UserSession.useAgentInfoOpt();
  let currentUserRole = match !== undefined ? match.membership.role : undefined;
  let match$1 = data.currentAccountV5;
  if (match$1 === undefined) {
    return null;
  }
  let fragmentRefs = match$1.fragmentRefs;
  return JsxRuntime.jsxs(ContentBox__Jsx3.make, {
    paddingFull: true,
    hasShadow: true,
    children: [
      JsxRuntime.jsx(PageUITitle.make, {
        title: "Users"
      }),
      JsxRuntime.jsx(SubusersPageAccountsList.make, {
        account: fragmentRefs,
        currentUserRole: currentUserRole
      }),
      JsxRuntime.jsx(SubusersAddUserForm.make, {
        account: fragmentRefs,
        currentUserRole: currentUserRole
      })
    ]
  });
}

let make = SubusersPageRelay;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
